export const sessionStartedSchema = {
  type: 'object',
  properties: {
    userId: { type: 'number' },
    username: { type: 'string' },
    email: { type: 'string' },
    name: { type: 'string' },
    isIntakePt: { type: 'boolean' },
    isLeadPt: { type: 'boolean' },
    isTreatmentPt: { type: 'boolean' },
  },
  required: ['userId', 'username', 'email', 'name', 'isIntakePt', 'isLeadPt', 'isTreatmentPt'],
}
